import { DegreeType } from '@teachur/http-client';

export const DEGREE_TOTAL_CREDITS: Record<DegreeType, number> = {
  [DegreeType.Associate]: 60,
  [DegreeType.Bachelor]: 60,
  [DegreeType.Master]: 30,
};

const DEFAULT_TOTAL_CREDITS = 60;

export const getDegreeTotalCredits = (type: DegreeType | undefined): number =>
  type ? DEGREE_TOTAL_CREDITS[type] : DEFAULT_TOTAL_CREDITS;
